import Policies from './Policies';
import Policy from './Policy';
import PolicyForm from './PolicyForm';
import React from 'react';
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';

const ArchiveControlRoutes = () => {
  const {path} = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/new`} exact component={PolicyForm} />
      <Route path={`${path}/:policyId/edit`} exact component={PolicyForm} />
      <Route path={`${path}/:policyId`} exact component={Policy} />
      <Route exact path={path}>
        <Policies />
      </Route>
      <Redirect to={path} />
    </Switch>
  );
};

export default ArchiveControlRoutes;
